import firebase from 'firebase/app';
import 'firebase/auth';
import 'firebase/database';
import 'firebase/storage';

let config = {
    apiKey: "AIzaSyDajsKkMyBMA_gfWmz1w9W2Rc_gvr03IXI",
    authDomain: "kinnected-aecf7.firebaseapp.com",
    databaseURL: "https://kinnected-aecf7.firebaseio.com",
    projectId: "kinnected-aecf7",
    storageBucket: "kinnected-aecf7.appspot.com",
    messagingSenderId: "758123351209"
};

const prodConfig = {
    apiKey: "AIzaSyBhMjW6v3W0ulOA8o7upkuAYgfUsuLOvRQ",
    authDomain: "kinnecedapp-prod.firebaseapp.com",
    databaseURL: "https://kinnecedapp-prod.firebaseio.com",
    projectId: "kinnecedapp-prod",
    storageBucket: "kinnecedapp-prod.appspot.com",
    messagingSenderId: "402676394037"
}

let nodeEnv =  process.env.REACT_APP_ENV_TYPE;

if(nodeEnv === 'PRODUCTION') {
    config = prodConfig;
}

if (!firebase.apps.length) {
    firebase.initializeApp(config);
}
const db = firebase.database();
const auth = firebase.auth();
const provider = new firebase.auth.FacebookAuthProvider();
const googleProvider = new firebase.auth.GoogleAuthProvider();
const storage = firebase.storage;

export {
  auth,
  db,
  provider,
  googleProvider,
  storage
};


// WEBPACK FOOTER //
// ./src/firebase/firebase.js